import { Box, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { UserDetailsContext } from '../../../context/user-details/user-details';
import { AvatarDisplay } from '../../presentation-components/display-elements-components/avatar-display';
import { ProfileEditForm } from '../../presentation-components/settings-components/profile-edit-form';
import UserDetailsService from '../../../shared/services/user-details/user-details.service';
import { IEmailDetails, IPasswordDetails, IUserDetails } from '../../../shared/services/user-details/user-details.model';
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications';
import gaiaTheme from '../../../root-components/theme';
import { ChangePasswordDialog } from '../../dialogs/settings/profile/change-password-dialog';
import { SettingsMobileNavbar } from '../../../root-components/navigation/settings-mobile-navbar';
import { PageTitle } from '../../presentation-components/display-elements-components/page-title';

export const SettingsProfilePage = () => {
  //Services
  const userDetailsContext = useContext(UserDetailsContext)
  const userNotificationsContext = useContext(UserNotificationsContext)
  const userDetailsService = new UserDetailsService();
  const userDetails = userDetailsContext.userDetails
  //State
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [errorCode, setErrorCode] = useState<number>()
  const [updatedUserDetails, setUpdatedUserDetails] = useState<IUserDetails>()
  const [editField, setEditField] = useState<string>('')
  const [emailDialogOpen, setEmailDialogOpen] = React.useState(false);
  const [emailNewDetails, setEmailNewDetails] = useState<IEmailDetails>({
    email: '',
  })
  const [passwordDialogOpen, setPasswordDialogOpen] = useState<boolean>(false)
  const [isSubmitting, setIsSumbitting] = useState<boolean>(false)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  //Use Effects
  useEffect(() => {
    setUpdatedUserDetails(userDetails)
  }, [])

  const capitaliseName = (): string => {
    if (userDetails) {
      const capitaiseFirstName = userDetails.firstName.charAt(0).toUpperCase() + userDetails.firstName.slice(1).toLowerCase()
      const capitaliseSurname = userDetails.surname.charAt(0).toUpperCase() + userDetails.surname.slice(1).toLowerCase()
      return `${capitaiseFirstName} ${capitaliseSurname}`;
    }
    return ''
  };

  const closeDialogHandler = () => {
    setEmailDialogOpen(false)
    setPasswordDialogOpen(false)
    setEditField('')
  }

  const submitHandler = async (postUser: IUserDetails) => {
    userDetailsService.editUserDetails(postUser)
      .then(response => {
        userDetailsContext.forceUpdateUserDetails();
        userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
      })
      .catch(err => {
        console.log(err)
        if (err.response.data.message) {
          setErrorMessage(err.response.data.message)
          setErrorCode(err.response.data.code)
        } else {
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        }
      })
  };

  // const submitEmailDialogHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   e.preventDefault()
  //   closeDialogHandler()
  //   setEmailNewDetails({ email: '' })
  // };

  const submitPasswordDialogHandler = async (passwordValues: IPasswordDetails) => {
    if (!isSubmitting) {
      setIsSumbitting(true)
      userDetailsService.editPasswordDetails(passwordValues)
        .then(response => {
          userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
          userDetailsContext.forceUpdateUserDetails();
          closeDialogHandler()
          setIsSumbitting(false)
        })
        .catch(err => {
          console.log(err)
          setIsSumbitting(false)
          setErrorMessage(err.response.data.message)
        })
    }
  };

  return (
    <Box sx={{ pb: isMobileMode ? 3 : 6, pl: isMobileMode ? 3 : 6, pr: isMobileMode ? 3 : 6, pt: isMobileMode ? 3 : 5, mt: isMobileMode ? 5 : 0, }}>
      {isMobileMode && userDetails && userDetails.roles.includes('admin') && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      <Stack sx={{ pb: 4, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {userDetails && <Box sx={{ mr: 3 }}>
          <AvatarDisplay color={userDetails.avatarColor} width={'75px'} height={'75px'} padding={2} userDetails={userDetails} fontSize='2.25rem' />
        </Box>}
        <Stack>
          <PageTitle title={capitaliseName()} />
          <Typography variant='body1' sx={{ color: 'text.secondary' }}> {userDetails?.email}</Typography>
        </Stack>
      </Stack>
      {/* <Stack direction='row' alignItems='center' sx={{ pb: 4 }}>
        <Box sx={{ mr: 3 }}>
          <AvatarDisplay color={'primary.light'} width={'75px'} height={'75px'} padding={2} userDetails={userDetails} fontSize='2.25rem' />
        </Box>
        <Button variant='text'>
          <UploadOutlined sx={{ color: 'primary.main' }} />
          <Typography sx={{ color: 'primary.main', display: 'inline' }}>Upload profile picture</Typography>
        </Button>
      </Stack> */}
      {updatedUserDetails && userDetails && <ProfileEditForm
        updatedUserDetails={updatedUserDetails}
        submitHandler={submitHandler}
        userDetails={userDetails}
        setEmailDialogOpen={setEmailDialogOpen}
        setPasswordDialogOpen={setPasswordDialogOpen}
        editField={editField}
        setEditField={setEditField}
        errorMessage={errorMessage}
        errorCode={errorCode}
      />}
      {/* <ChangeEmailDialog
        title={'Change Email Address'}
        description={'Please enter your new email address, you will be sent a verification email'}
        submitButtonText={'Save'}
        open={emailDialogOpen}
        closeHandler={closeDialogHandler}
        dialogDetails={emailNewDetails}
        setDialogDetails={setEmailNewDetails}
        submitHandler={submitEmailDialogHandler} /> */}
      {passwordDialogOpen && <ChangePasswordDialog
        open={passwordDialogOpen}
        closeHandler={closeDialogHandler}
        submitHandler={submitPasswordDialogHandler}
        errorMessage={errorMessage}
        isSubmitting={isSubmitting}
      />}
    </Box>
  );
};